import { render, staticRenderFns } from "./AudioStart.vue?vue&type=template&id=0e467a5a&scoped=true&"
import script from "./AudioStart.vue?vue&type=script&lang=ts&"
export * from "./AudioStart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e467a5a",
  null
  
)

export default component.exports